throw new Error(`
Don't import the main file!
Import specific utils, example:
'import resolveColor from "@semcore/lib/color"'
`);
